import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Search } from 'lucide-react';
const faqCategories = [{
  title: 'General Questions',
  faqs: [{
    q: 'What is Poch Global?',
    a: 'Poch Global is Africa\'s premier platform connecting people worldwide to African heritage, culture, education, and innovation.'
  }, {
    q: 'Where are you located?',
    a: 'We operate globally with our headquarters in New York, and various program locations across Africa and the diaspora.'
  }, {
    q: 'How can I get involved?',
    a: 'You can get involved by donating, volunteering, attending our events, or partnering with us.'
  }]
}, {
  title: 'Program Questions',
  faqs: [{
    q: 'How can I apply for a program?',
    a: 'You can apply for our programs through the specific program pages on our website or by contacting our admissions team.'
  }, {
    q: 'Do you offer scholarships?',
    a: 'Yes, we offer various scholarships for our educational and tech training programs based on merit and need.'
  }, {
    q: 'What is Wonder Boy?',
    a: 'Wonder Boy is our flagship restaurant and training center where youth receive hands-on culinary and hospitality training.'
  }]
}, {
  title: 'Donation Questions',
  faqs: [{
    q: 'How do I make a donation?',
    a: 'You can make a secure online donation using credit card, PayPal, or bank transfer via our Donate page.'
  }, {
    q: 'Is my donation tax-deductible?',
    a: 'Yes, Poch Global is a registered 501(c)(3) nonprofit organization, and all donations are tax-deductible to the extent allowed by law.'
  }, {
    q: 'Can I set up a monthly recurring donation?',
    a: 'Absolutely! You can choose the "Monthly" option on our donation form to become a sustaining supporter.'
  }]
}, {
  title: 'Event & Volunteer Questions',
  faqs: [{
    q: 'How can I volunteer?',
    a: 'Visit our Volunteer page to see open roles and submit an application. We offer both in-person and remote opportunities.'
  }, {
    q: 'Do I need prior experience to volunteer?',
    a: 'While some specialized roles require experience, many of our volunteer positions only require passion and a willingness to learn.'
  }, {
    q: 'How do I register for an event?',
    a: 'You can register for upcoming events directly through our Events page by clicking the "Register" button on the event card.'
  }]
}];
export function FAQ() {
  const [activeFaq, setActiveFaq] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  return <div className="pt-0 bg-warmwhite min-h-screen" data-id="element-889" data-mp="2l815m253ze02">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-navy overflow-hidden" data-id="element-890" data-mp="302p8d8j4jybz">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-891" data-mp="2v3umtytrvvo6" />
        <div className="container relative z-10 mx-auto px-6 md:px-12 text-center" data-id="element-892" data-mp="15ppvhn64pi8e">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-893" data-mp="10ren7gvhffsa">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-894" data-mp="3hc9wljcurqmp">
              Frequently Asked Questions
            </h1>
            <p className="text-lg text-white/80 max-w-2xl mx-auto mb-10" data-id="element-895" data-mp="32n3zq21hmchz">
              Find answers to common questions about our programs, donations, and how to get involved.
            </p>
            
            <div className="max-w-xl mx-auto relative" data-id="element-896" data-mp="2tlnojs2um6cp">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-mediumgray w-5 h-5" data-id="element-897" data-mp="2xp28gttwr6vf" />
              <input type="text" placeholder="Search for answers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-6 py-4 rounded-full bg-white border-none focus:ring-2 focus:ring-gold outline-none shadow-lg text-charcoal" data-id="element-898" data-mp="2jpknyqnnafrv" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 lg:py-16" data-id="element-899" data-mp="2ix9rlprvjyjo">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl" data-id="element-900" data-mp="2e0b07ezli5p6">
          {faqCategories.map((category, catIdx) => {
          const filteredFaqs = category.faqs.filter(faq => faq.q.toLowerCase().includes(searchQuery.toLowerCase()) || faq.a.toLowerCase().includes(searchQuery.toLowerCase()));
          if (filteredFaqs.length === 0) return null;
          return <div key={catIdx} className="mb-12" data-id="element-901" data-mp="1v8i8dnw9iqj1" data-mpi={catIdx}>
                <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-902" data-mp="1qagncxfa0h4x">{category.title}</h2>
                <div className="space-y-4" data-id="element-903" data-mp="1m9d4s35ug700">
                  {filteredFaqs.map((faq, i) => {
                const id = `${catIdx}-${i}`;
                return <div key={i} className="bg-white border border-softgray rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-904" data-mp="1hcczhugtj89y" data-mpi={i}>
                        <button onClick={() => setActiveFaq(activeFaq === id ? null : id)} className="w-full px-6 py-5 flex items-center justify-between hover:bg-lightgray transition-colors text-left" data-id="element-905" data-mp="3nzc4dnzrbmf8">
                          <span className="font-bold text-navy" data-id="element-906" data-mp="5tfu36qhcsys">{faq.q}</span>
                          <ChevronDown className={`w-5 h-5 text-mediumgray transition-transform duration-300 shrink-0 ${activeFaq === id ? 'rotate-180' : ''}`} data-id="element-907" data-mp="3581dh6u179nc" />
                        </button>
                        <AnimatePresence data-id="element-908" data-mp="3a4rr7nid5t5l">
                          {activeFaq === id && <motion.div initial={{
                      height: 0,
                      opacity: 0
                    }} animate={{
                      height: 'auto',
                      opacity: 1
                    }} exit={{
                      height: 0,
                      opacity: 0
                    }} className="overflow-hidden" data-id="element-909" data-mp="3e6wjoix2sjqn">
                              <div className="px-6 pb-5 text-mediumgray border-t border-softgray pt-4 leading-relaxed" data-id="element-910" data-mp="3ttj1hzzivo85">
                                {faq.a}
                              </div>
                            </motion.div>}
                        </AnimatePresence>
                      </div>;
              })}
                </div>
              </div>;
        })}
        </div>
      </section>
    </div>;
}